import { Card, CardContent, Box, Skeleton } from '@mui/material';
import { useCurrentHash } from '../hooks/hashs/useCurrentHash';

const Row = ({ icon = true, width = '70%' }) => (
  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
    {icon && <Skeleton variant="circular" width={20} height={20} />}
    <Skeleton variant="text" width={width} height={22} />
  </Box>
);

const CardLoading = () => {

  const { hashElemment } = useCurrentHash();

  return (
    <Card
      variant="outlined"
      sx={{
        flexGrow: 0,
        flexShrink: 0,
        flexBasis: {
          xs: '100%',
          sm: hashElemment === 'TripCard'
            ? '100%'
            : 'calc(50% - 16px)',
          xl: hashElemment === 'TripCard'
            ? 'calc(50% - 16px)'
            : 'calc(33% - 16px)'
        },
        maxWidth: '100%'
      }}
    >
      {hashElemment === 'TripCard' && (
        <>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, px: 2, pt: 2 }}>
            <Skeleton variant="circular" width={22} height={22} />
            <Skeleton variant="text" width="60%" height={28} />
          </Box>

          <CardContent sx={{ display: 'flex', gap: 2 }}>

            <Box sx={{ flex: '1 20%', display: 'flex', flexDirection: 'column', gap: 1 }}>
              <Row />
              <Row width="80%" />
              <Row width="50%" />
              <Row width="60%" />
              <Row width="60%" />
              <Row width="40%" />
            </Box>

            <Box sx={{ flex: '1 80%', display: 'flex', flexDirection: 'column', gap: 2 }}>
              
              <Row width="40%" />

              <Skeleton variant="rectangular" height={120} />

              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <Skeleton variant="text" width={40} />
                <Skeleton variant="rectangular" height={6} sx={{ flex: 1, borderRadius: 3 }} />
              </Box>

            </Box>

          </CardContent>
        </>
      )}

      {hashElemment === 'LineCard' && (
        <CardContent sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
          <Row width="60%" />
          <Row width="70%" />
          <Row width="50%" />
          <Row width="40%" />
        </CardContent>
      )}

    </Card>
  );
};

export default CardLoading;